import { NotificationEventResponse } from '../../interfaces/NotificationData';

export const PUSH_TAG = 'push';

export interface PushState {
  token: any;
  activePush: NotificationEventResponse | undefined;
}
